import React, { useEffect, useState, createContext, useContext } from 'react';
import Navigation from './Navigation';
import { Footer } from './Footer';
import ContextualHelp from '@/components/help/ContextualHelp';
import { useSettingsEffects } from '@/hooks/use-settings-effects';
import { HelpSystem } from '@/components/help';

// Create context for Help modal
export const HelpModalContext = createContext({ openHelp: () => {} });

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Apply settings effects throughout the app
  useSettingsEffects();

  const [helpOpen, setHelpOpen] = useState(false);

  // Provide openHelp function to context
  const openHelp = () => setHelpOpen(true);
  const closeHelp = () => setHelpOpen(false);

  return (
    // WARNING: Do not add overflow: auto/hidden/scroll to this parent div or sticky header will break.
    <HelpModalContext.Provider value={{ openHelp }}>
      <div className="flex flex-col min-h-screen">
        <Navigation />
        <main className="flex-grow">
          <div className="container mx-auto px-2 sm:px-4 py-4 sm:py-8">
            {children}
          </div>
        </main>
        <Footer />
        <ContextualHelp />
        {/* Global HelpSystem modal, opens via context */}
        {helpOpen && <HelpSystem onClose={closeHelp} />}
      </div>
    </HelpModalContext.Provider>
  );
};

export default Layout;
